import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ConfirmationCancelTransferModal = ({ show, onHide, onConfirm, message }) => {
    React.useEffect(() => {
        if (show) {
            MySwal.fire({
                title: 'Confirmation requise',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Oui, annuler',
                cancelButtonText: 'Non, garder',
                reverseButtons: true,
                customClass: {
                    container: 'sweet-alert-container',
                    popup: 'sweet-alert-popup',
                    title: 'sweet-alert-title',
                    content: 'sweet-alert-content',
                    confirmButton: 'sweet-alert-confirm-btn',
                    cancelButton: 'sweet-alert-cancel-btn'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    onConfirm();
                }
                onHide();
            });
        }
    }, [show, message, onHide, onConfirm]);

    return null;
};

export default ConfirmationCancelTransferModal;